import { useContext, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import { AlertContext } from "../context/AlertContext";
import { domain } from "../consts";
import { SVGS } from ".";
import { validateEmail, validatePassword } from "../utils/validate";
import { LoginStrings } from "../consts/strings";

const LoginForm = ({ setDisplayComponent, formDisplay }) => {
  const { setUpdate } = useContext(AuthContext);
  const { handleAlert } = useContext(AlertContext);

  const [isLoading, setLoading] = useState(false);

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const [formErr, setFormErr] = useState({
    email: false,
    password: false,
  });

  const handleGoogleLogin = () => {
    window.location.href = `${domain}/auth/google`;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name === "email") {
      setFormErr((prev) => ({
        ...prev,
        email: !validateEmail(value),
      }));
    }

    if (name === "password") {
      setFormErr((prev) => ({
        ...prev,
        password: !validatePassword(value),
      }));
    }
  };

  const handleFormLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (formErr.email || !form.email.length) {
      handleAlert(LoginStrings.emailAlert, "warning");
      setLoading(false);
      return;
    } else if (formErr.password || !form.password.length) {
      handleAlert(LoginStrings.passwordAlert, "warning");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`${domain}/login`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: form.email,
          password: form.password,
        }),
      });

      if (!response.ok) {
        const errorMessage = await response.text();
        throw new Error(errorMessage);
      }
      setUpdate(true);
      window.location.assign("/moje-pozivnice");
    } catch (error) {
      handleAlert(LoginStrings.loginAlert, "error");
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="w-full max-w-md mx-auto p-6">
      <div className="mt-7 bg-white border border-gray-200 rounded-xl shadow-sm    ">
        <div className="p-4 sm:p-7">
          <div className="text-center">
            <h1 className="block text-2xl font-bold text-gray-800  ">
              {LoginStrings.header}
            </h1>
            <p className="mt-2 text-sm text-gray-600  ">
              {LoginStrings.paragraph}
              <a
                className="cursor-pointer text-teal-600 decoration-2 hover:underline font-medium  :outline-none  :ring-1  :ring-gray-600"
                onClick={() => setDisplayComponent(formDisplay.signup)}
              >
                {" "}
                {LoginStrings.registerButton}
              </a>
            </p>
          </div>
          <div className="mt-5">
            <button
              type="button"
              className="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none        :bg-gray-800  :outline-none  :ring-1  :ring-gray-600"
              onClick={handleGoogleLogin}
              disabled={isLoading}
            >
              <SVGS.GoogleSVG /> {LoginStrings.googleButton}
            </button>
            <div className="py-3 flex items-center text-xs text-gray-400 uppercase before:flex-[1_1_0%] before:border-t before:border-gray-200 before:me-6 after:flex-[1_1_0%] after:border-t after:border-gray-200 after:ms-6    :border-gray-600  :border-gray-600">
              {LoginStrings.or}
            </div>
            <form onSubmit={handleFormLogin} noValidate>
              <div className="grid gap-y-4">
                <div>
                  <label
                    htmlFor="email"
                    className="block text-sm mb-2  "
                  >
                    {LoginStrings.emailAddress}
                  </label>
                  <div className="relative">
                    <input
                      type="email"
                      id="email"
                      name="email"
                      autoComplete="email"
                      onChange={handleChange}
                      className="py-3 px-4 block w-full border-gray-200 rounded-lg text-sm focus:border-teal-500 focus:ring-teal-500 disabled:opacity-50 disabled:pointer-events-none        :ring-gray-600"
                      // aria-describedby="email-error"
                      disabled={isLoading}
                    />
                    <div
                      className={`${
                        !formErr.email && "hidden"
                      } mt-1 absolute inset-y-2 end-0 pointer-events-none pe-3`}
                    >
                      <SVGS.ErrorSVG />
                    </div>
                  </div>
                  <p
                    className={`${
                      !formErr.email && "hidden"
                    } text-xs text-red-600 mt-2`}
                    id="password-error"
                  >
                    {LoginStrings.emailErr}
                  </p>
                </div>
                <div>
                  <div className="flex justify-between items-center">
                    <label
                      htmlFor="password"
                      className="block text-sm mb-2  "
                    >
                      {LoginStrings.password}
                    </label>
                    <a
                      className="text-sm text-teal-600 decoration-2 hover:underline font-medium  :outline-none  :ring-1  :ring-gray-600 cursor-pointer"
                      onClick={() => setDisplayComponent(formDisplay.forgot)}
                    >
                      {LoginStrings.forgotPasswordButton}
                    </a>
                  </div>
                  <div className="relative">
                    <input
                      type="password"
                      id="password"
                      name="password"
                      autoComplete="new-password"
                      onChange={handleChange}
                      className="py-3 px-4 block w-full border-gray-200 rounded-lg text-sm focus:border-teal-500 focus:ring-teal-500 disabled:opacity-50 disabled:pointer-events-none        :ring-gray-600"
                      aria-describedby="password-error"
                      disabled={isLoading}
                    />
                    <div
                      className={`${
                        !formErr.password && "hidden"
                      } mt-1 absolute inset-y-2 end-0 pointer-events-none pe-3`}
                    >
                      <SVGS.ErrorSVG />
                    </div>
                    <p
                      className={`${
                        !formErr.password && "hidden"
                      } text-xs text-red-600 mt-2`}
                      id="password-error"
                    >
                      {LoginStrings.passwordErr}
                    </p>
                  </div>
                </div>
                <button
                  type="submit"
                  className="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent bg-teal-600 text-white hover:bg-teal-700 disabled:opacity-50 disabled:pointer-events-none  :outline-none  :ring-1  :ring-gray-600"
                  disabled={isLoading}
                >
                  {isLoading
                    ? LoginStrings.loginButtonLoading
                    : LoginStrings.loginButton}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </main>
  );
};

export default LoginForm;
